import { useEffect } from 'react';
import { useIdentityContext } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import {
    PAGE_TRACKING_CONFIG,
    sendPersonalisationRetrievedTrackingEvent,
} from '@99designs/tracking';
import { useGetBrandProfilesLazyQuery } from '../../graphql';

export function Personalisation({ mpvId }: { mpvId: string }) {
    const [getBrandProfile] = useGetBrandProfilesLazyQuery({
        onCompleted: (data) => {
            if (!data || data.brandProfiles.length === 0) {
                return null;
            }

            const pageTracking = PAGE_TRACKING_CONFIG['product-page'];
            sendPersonalisationRetrievedTrackingEvent({
                pageName: `${mpvId}-design:${pageTracking.pageSection}`,
                ...pageTracking,
                label: 'Design Services:Hub Page:Personalisation',
                eventDetail: `${data.brandProfiles.length} retrieved`,
            });

            return null;
        },
    });

    const { isSignedIn } = useIdentityContext();

    useEffect(() => {
        if (isSignedIn) {
            getBrandProfile();
        }
    }, [getBrandProfile, isSignedIn]);

    return null;
}
